import { Component, OnInit, ViewChild } from "@angular/core";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { DashboardBizzDevService } from "../../../shared/services/dashboard-bizz-dev.service";

@Component({
    selector: "app-bizzmine",
    templateUrl: "./bizzmine.component.html",
    styleUrls: ["./bizzmine.component.scss"],
})
export class BizzmineComponent implements OnInit {
    displayedColumns = ["subject", "description"];
    dataSource;
    @ViewChild(MatSort)
    sort: MatSort;
    constructor(
        private dashboardSrv: DashboardBizzDevService,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.getReleaseNotes();
    }
    getReleaseNotes() {
        this.dashboardSrv.getReleaseNotes().subscribe((value) => {
            this.dataSource = new MatTableDataSource(value);
            if (this.sort) {
                this.dataSource.sort = this.sort;
            }
        });
    }
}
